/**
 * True when this document is rendered inside an iframe (e.g. the Viedoc
 * Designer preview pane). Comparing window references is allowed even for
 * cross-origin parents; reading properties of window.top is not.
 */
export const isEmbedded = () => window.self !== window.top;
